import { useEffect, useState } from 'react';
import styles from "./GarageDoorSurfaces.module.css";

export default function GarageDoorSurfaces({ packageData, handleSurfaceSelect }) {
    const [selectedSurface, setSelectedSurface] = useState(null);

    useEffect(() => {
        // Select the first surface by default whenever the package data changes
        if (packageData && packageData.garageDoor) {
            const firstSurface = packageData.garageDoor.split(',')[0];
            setSelectedSurface(firstSurface);
            handleSurfaceSelect({ target: { value: firstSurface, getAttribute: () => 'GARAGE DOOR' } });
        }
    }, [packageData]);

    const surfaces = packageData != null ? (
        packageData.garageDoor.split(',').map((surface, index) => (
            <li key={`${index}`}>
                <label htmlFor={index}>{surface}</label>
                <input
                    type="radio"
                    name="garageSurfaces"
                    id={index}
                    data-surface-name="GARAGE DOOR"
                    value={surface}
                    onChange={(e) => {
                        setSelectedSurface(surface);
                        handleSurfaceSelect(e);
                    }}
                    aria-label="surface selector"
                    checked={surface === selectedSurface}
                />
            </li>
        ))
    ) : (
        <li>No surfaces</li>
    );

    return (
        <div className={styles.content}>
            <p>Garage Door:</p>
            <ul>
                {surfaces.length ? surfaces : <li>No surfaces</li>}
            </ul>
        </div>
    );
}
